import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from '~/components/organisms/instantSearch/instantSearch.module.scss';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { UseCategoryResultsResult } from '~/hooks/useCategoryResults';
import { categoryResultsCount } from '../constants';
import sidebarStyles from '../instantSearchSidebar.module.scss';
import InstantCategoryResult from './InstantCategoryResult';

interface InstantCategoryListProps {
    categoryResult: UseCategoryResultsResult['categoryResults'][number];
}

export const InstantCategoryList = ({ categoryResult }: InstantCategoryListProps) => {
    const { handleGoToResult } = useSERPActions();

    return (
        <>
            <div key={categoryResult.result.querySetIdentifier}>
                <div
                    role="heading"
                    aria-level={2}
                    className={classNames(styles.instantResultsTitle, sidebarStyles.instantSidebarTitle)}
                    data-testid="insantsearch-sidebar-ttitle"
                >
                    {typeof categoryResult.title === 'string' ? (
                        categoryResult.title
                    ) : (
                        <FormattedMessage id="categories_title" defaultMessage="Nalezeno v kategoriích" />
                    )}
                </div>
                <ul className={sidebarStyles.instantSidebarList} data-testid="instantsearch-list">
                    {categoryResult.result.hits.slice(0, categoryResultsCount).map((category, index: number) => (
                        <InstantCategoryResult
                            category={category}
                            order={index + 1}
                            handleGoToResult={handleGoToResult}
                            key={index}
                        />
                    ))}
                </ul>
            </div>
        </>
    );
};
